import React from "react";
import HeaderBar from "../header/HeaderBar";

export const FeaturesHeader = props => (
  <HeaderBar
    user={props.user}
    userData={props.userData}
    features
    handleBack={props.handleBackClick}
  />
);
